export const TOGGLE_SIZES = {
  MD: 'md',
  LG: 'lg'
}
